export class DataTransfer {
  /**
   *
   * @param {Form} form
   */
  constructor(dataEntry) {
    this.dataEntry = dataEntry;
    this.storageKey = "transferData";
    this.form = document.querySelector("form[name^=create_]");

    if (this.inViewMode()) {
      return;
    }

    const elements = document.querySelectorAll(".data-transfer > .hidden");

    elements.forEach((el) => {
      if (this.form.name !== "create_sendingreceiving") {
        this.show(el);
      }
      if (this.form.name === "create_processing") {
        const checkbox = el.querySelector('input[type="checkbox"]');
        this.show(el, !checkbox.name.includes("transferToProcessing"));
      }
      this.listener(el);
    });

    this.store.bind(this);
    this.prepopulate.bind(this);
  }

  /**
   *
   * @param {*} el
   * @param {*} display
   */
  show(el, display = true) {
    if (display) {
      el.classList.remove("hidden");
    } else {
      el.classList.add("hidden");
    }
  }

  /**
   *
   * @returns
   */
  inViewMode() {
    const layout = document.querySelector(".dataentry-layout");

    return !layout || layout.dataset.isView === "true" || layout.dataset.isHistory === "true";
  }

  /**
   *
   * @returns
   */
  isTargetForm() {
    return ["create_sendingreceiving", "create_processing"].includes(this.form.name);
  }

  /**
   * @param {Element} formGroup - the select element parent node
   * @param {Element} select    - the sendingreceiving 'process' select node
   */
  listener(element) {
    const checkbox = element.querySelector('input[type="checkbox"]');
    $(checkbox).on("ifChanged", (e) => {
      e.preventDefault();
      const checked = $(e.currentTarget).is(":checked");
      const checkboxes = $(".data-transfer").find("input[type=checkbox]");
      $(checkboxes).each((i, el) => {
        if (checked && checkbox !== el) {
          $(el).iCheck("uncheck");
        }
      });
    });
    if (!checkbox.name.includes("transferToProcessing")) {
      const select = document.querySelector("select[name^=sendingreceiving]");
      if (select !== null) {
        if (select.value === "ARRIVING") {
          this.show(element);
        }
        /*
         * 'change' event registered by jQuery because atlant/bootstrap-js version is too old:
         * https://github.com/snapappointments/bootstrap-select/issues/1027
         */
        $(select).on("change", () => {
          this.show(element, select.value === "ARRIVING");
        });
      }
    }
  }

  /**
   *
   */
  store() {
    const transferCheckboxes = document.querySelectorAll(".data-transfer input[type='checkbox']");
    let transferData = false;
    transferCheckboxes.forEach((el) => {
      transferData = el.checked ? true : transferData;
    });
    if (transferData) {
      this.storeBatch();
    }
  }

  /**
   *
   */
  storeBatch() {
    const batch = [];
    let batchRows = null;

    switch (this.form.name) {
      case "create_sendingreceiving":
        const businessStep = document.querySelector('[name="sendingreceiving[businessStep]"]');
        const isArrivingSelected = businessStep && businessStep.value === "ARRIVING";
        if (isArrivingSelected) {
          batchRows = "#sendingreceiving-identification #identification_rows tr";
        }
        break;
      case "create_processing":
        batchRows = "#outputIdentification_rows tr";
        break;
      case "create_slaughtering":
        batchRows = "#slaughter-meatPart #meatPart_rows tr";
        break;
      default:
        batchRows = `form#${this.form.name}`;
    }

    document.querySelectorAll(batchRows).forEach((el) => {
      const gtinSelect = el.querySelector("#gtin") || el.querySelector(".gtin");
      const gtinEl = gtinSelect.selectedIndex ? gtinSelect[gtinSelect.selectedIndex] : gtinSelect;
      const gtinVal = gtinEl.innerHTML.split("::");
      const lot = el.querySelector("#lot") || el.querySelector(".lot");
      const quantity = el.querySelector('input[name$="[quantity]"]') || el.querySelector(".quantity");
      const uom = el.querySelector("#uom") || el.querySelector(".uom");

      batch.push({
        name: gtinVal[1].trim(),
        gtin: gtinVal[0].trim(),
        lot: lot.value || lot.dataset.lot || lot.innerHTML,
        quantity: quantity.value,
        uom: uom.value || uom.dataset.uom,
      });
    });

    this.dataEntry.storage.set(`${this.storageKey}[batch]`, JSON.stringify(batch));
  }

  /**
   *
   * @param {*} form
   * @returns
   */
  prepopulate(form) {
    const transferData = JSON.parse(this.dataEntry.storage.get(`${this.storageKey}[batch]`));

    if (!transferData || this.inViewMode() || !this.isTargetForm()) {
      return;
    }

    if (this.form.name === "create_sendingreceiving") {
      let selectProcess = document.querySelector("select[name^=sendingreceiving]");
      if (selectProcess === null || !transferData) {
        return;
      }
      let select = document.querySelector("select[name='sendingreceiving[businessStep]']");
      let datepicker = document.querySelector("input[name='sendingreceiving[eventTime]']");

      $(select).val("DEPARTING");
      $(select).trigger("change");
      $(datepicker).datepicker("setDate", "today");
    }

    form.setBatch(transferData);

    this.dataEntry.storage.remove(`${this.storageKey}[batch]`);
  }
}
